import React, { useState, useEffect } from "react";
import { Nav, Container, Button } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import profileIcon from "../assets/images/users/user-dummy-img.jpg";
import "../assets/scss/custom-colors.scss";
import { getUserProfile } from "../Common/data/getUserProfile";

// Define an interface for the user data
interface UserData {
    fullName: string;
    email: string;
    // Add other properties as needed
}

const ProfileHeader = () => {

    const [profilePicture, setProfilePicture] = useState("");
    const location = useLocation();
    const [activeLink, setActiveLink] = useState<string>("dashboard"); // State to track active link

    const [userData, setUserData] = useState<UserData | null>(null);

    useEffect(() => {
        // Retrieve user data from local storage
        const storedUserData = JSON.parse(localStorage.getItem("userData") || "{}") as UserData;
        setUserData(storedUserData);
    }, []);


    // Update active link state based on current route
    useEffect(() => {
        const path = location.pathname;
        setActiveLink(path.substring(1)); // Remove leading slash
    }, [location.pathname]);

    useEffect(() => {
        // Fetch user profile data when the component mounts
        const fetchUserProfile = async () => {
            try {
                const userData = await getUserProfile();
                setProfilePicture(userData.results.profile_image_url);
            } catch (error:any) {
                console.error("Error fetching user profile:", error.message);
            }
        };

        fetchUserProfile();
    }, []);

    return (
        <div className="custom-bg-primary py-2">
            <Container>
                <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                        <img
                            src={profilePicture}
                            alt="Profile"
                            height="60"
                            className="d-inline-block align-top mr-4"
                            style={{ borderRadius: "20%" }} // Remove rounded edges
                        />
                        <div style={{ marginLeft: "1rem" }}> {/* Add margin to the left */}
                            <p className="m-0 font-weight-bold h5 text-white">{userData ? userData.fullName : ""}</p> {/* Replace with user's name */}
                            <p className="m-0 h6 text-white">Applicant</p> {/* Replace with user's status */}
                        </div>
                    </div>
                    <Link to="/settings"> {/* Link to the settings page */}
                        <Button variant="primary" className="text-white mt-3 custom-primary-btn">Account Settings</Button>
                    </Link>
                </div>
                <hr className="mt-4 text-white" /> {/* Horizontal rule */}
                <Nav className="pb-2">
                    <Nav.Item>
                        <Nav.Link
                            href="/#/dashboard"
                            className={`text-white ${activeLink === "dashboard" ? "active" : ""}`} // Add active class conditionally
                            style={{ borderBottom: activeLink === "dashboard" ? "2px solid white" : "none" }} // Add border style conditionally
                        >
                            Dashboard
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link
                            href="/#/application"
                            className={`text-white ${activeLink === "application" ? "active" : ""}`} // Add active class conditionally
                            style={{ borderBottom: activeLink === "application" ? "2px solid white" : "none" }} // Add border style conditionally
                        >
                            Application
                        </Nav.Link>
                    </Nav.Item>
                </Nav>
            </Container>
        </div>
    );
};

export default ProfileHeader;
